import React from 'react';
import { Mail, MapPin, Phone, ExternalLink } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3 className="footer-title">ISKCON Boston</h3>
            <div className="contact-info">
              <div className="contact-item">
                <MapPin className="w-4 h-4" />
                <span>72 Commonwealth Ave, <br /> Boston, Massachusetts</span>
              </div>
              <div className="contact-item">
                <Mail className="w-4 h-4" />
                <a href="mailto:iskconboston.dharma@gmail.com">
                  iskconboston.dharma@gmail.com
                </a>
              </div>
            </div>
          </div>
          
          <div className="footer-section">
            <div className="qr-section">
              <h4 className="footer-subtitle qr-title">Quick Donate</h4>
              <img
                src="https://i.postimg.cc/HWqY3RTr/donation-qr.jpg"
                alt="Donation QR Code"
                className="donation-qr"
              />
              <p className="qr-text">Scan to donate via mobile</p>
            </div>
          </div>
          
          <div className="footer-section">
            <h4 className="footer-subtitle">Connect With Us</h4>
            <div className="links-section">
              <a href="https://iskconboston.org/" className="footer-link">
                <ExternalLink className="w-4 h-4" />
                ISKCON Boston Website
              </a>
              <a href="https://www.facebook.com/ISKCONBoston/" className="footer-link">
                <ExternalLink className="w-4 h-4" />
                Follow Us on Social Media
              </a>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p className="copyright">
            Copyright © 2025 ISKCON Boston. All Rights Reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;